import AboutUsContainer from "./containers/AboutUsContainer";
import "./styles.scss";

export default AboutUsContainer;
